import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail } from 'lucide-react';
import { FaViber, FaWhatsapp, FaTelegram } from 'react-icons/fa';
import { getSettings } from '../api';

const Footer = () => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const response = await getSettings();
      setSettings(response.data);
    } catch (error) {
      console.error('Failed to load settings:', error);
    }
  };

  const siteSettings = settings || {
    companyName: "Мандарин",
    phone: "+375 29 186-13-40",
    email: "info@mandarin-cleaning.by",
    messengers: {
      viber: "viber://chat?number=%2B375291861340",
      whatsapp: "https://wa.me/375291861340",
      telegram: "https://t.me/+375291861340"
    }
  };
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img
                src="/logo.png"
                alt="Mandarin"
                className="w-12 h-12 object-contain"
              />
              <span className="text-2xl font-bold">{siteSettings.companyName}</span>
            </div>
            <p className="text-gray-400 leading-relaxed">
              Клининговая компания с 5-летним опытом работы на рынке Минска.
            </p>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Наши услуги</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/podderzhivayushhaya-uborka"
                  className="text-gray-400 hover:text-orange-400 transition-colors"
                >
                  Поддерживающая уборка
                </Link>
              </li>
              <li>
                <Link
                  to="/generalnaya-uborka"
                  className="text-gray-400 hover:text-orange-400 transition-colors"
                >
                  Генеральная уборка
                </Link>
              </li>
              <li>
                <Link
                  to="/uborka-posle-remonta"
                  className="text-gray-400 hover:text-orange-400 transition-colors"
                >
                  Уборка после ремонта
                </Link>
              </li>
              <li>
                <Link
                  to="/uborka-kuhni"
                  className="text-gray-400 hover:text-orange-400 transition-colors"
                >
                  Уборка кухни
                </Link>
              </li>
              <li>
                <Link
                  to="/uborka-sanuzla"
                  className="text-gray-400 hover:text-orange-400 transition-colors"
                >
                  Уборка санузла
                </Link>
              </li>
              <li>
                <Link
                  to="/himchistka"
                  className="text-gray-400 hover:text-orange-400 transition-colors"
                >
                  Химчистка
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Контакты</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href={`tel:${siteSettings.phone}`}
                  className="flex items-center space-x-2 text-gray-400 hover:text-orange-400 transition-colors"
                >
                  <Phone className="w-5 h-5" />
                  <span>{siteSettings.phone}</span>
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${siteSettings.email}`}
                  className="flex items-center space-x-2 text-gray-400 hover:text-orange-400 transition-colors"
                >
                  <Mail className="w-5 h-5" />
                  <span>{siteSettings.email}</span>
                </a>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Мы в мессенджерах</h3>
            <div className="flex items-center space-x-3">
              <a
                href={siteSettings.messengers.viber}
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 flex items-center justify-center bg-purple-500 hover:bg-purple-600 rounded-full transition-colors"
              >
                <FaViber className="w-6 h-6" />
              </a>
              <a
                href={siteSettings.messengers.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 flex items-center justify-center bg-green-500 hover:bg-green-600 rounded-full transition-colors"
              >
                <FaWhatsapp className="w-6 h-6" />
              </a>
              <a
                href={siteSettings.messengers.telegram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 flex items-center justify-center bg-blue-500 hover:bg-blue-600 rounded-full transition-colors"
              >
                <FaTelegram className="w-6 h-6" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} {siteSettings.companyName}. Все права защищены. v0.1.1</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;